import { CFG } from '../config';
import { dayName, todayStr } from '../utils';
import type { DayData } from '../types';

interface Props {
  days: DayData[];
}

function barColor(total: number, isToday: boolean): string {
  if (isToday) return 'var(--cyan)';
  if (total === 0) return 'var(--dim2)';
  const [lo, hi] = CFG.calRange;
  if (total >= lo && total <= hi) return 'var(--green)';
  if (total >= lo - 200 && total <= hi + 200) return 'var(--yellow)';
  return 'var(--magenta)';
}

export function CalorieChart({ days }: Props) {
  const max = Math.max(...days.map((d) => d.total || 0), 1);
  const today = todayStr();
  const targetPct = Math.min(CFG.targetCal / max * 100, 100);

  return (
    <div class="chart">
      <div class="bars">
        {days.map((d) => {
          const pct = (d.total || 0) / max * 100;
          const isToday = d.date === today;
          const color = barColor(d.total, isToday);
          return (
            <div key={d.date} class={`bar-col ${isToday ? 'today' : ''}`}>
              <div
                class="bar-stick"
                style={{
                  height: `${Math.max(pct, 2)}%`,
                  borderColor: color,
                  background: `rgba(255,255,255,${d.total ? 0.08 : 0.02})`,
                }}
              />
              <div class="bar-day">{dayName(d.date)}</div>
            </div>
          );
        })}
        <div class="target-line" style={{ bottom: `${targetPct}%` }}>
          <span class="target-label">target</span>
        </div>
      </div>
    </div>
  );
}
